import React from 'react';
import { IconProps, layout, palette, typography } from '@citrite/web-ui-component';
import styled from '@emotion/styled';

const menuItemIconSize = 20;
const menuItemIconColor = palette.black;

const StyledLabel = styled.label`
	font-size: ${layout.mediumSpace};
	font-weight: ${typography.weights.regular};
`;

const MenuItemWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: ${layout.smallSpace};
	padding: ${layout.smallSpace} 0;
	line-height: normal;
`;

interface Props {
	icon?: React.ComponentType<IconProps>;
	children: React.ReactNode;
}

export const ResourceMenuAction = ({ icon: IconComponent, children }: Props) => (
	<MenuItemWrapper>
		{IconComponent && <IconComponent size={menuItemIconSize} color={menuItemIconColor} />}
		<StyledLabel>{children}</StyledLabel>
	</MenuItemWrapper>
);
